import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';

import getBuInfo from '../../api/shop/buInfo';
import createConsignment from '../../api/cars/createConsignment';
import HookForm from '../../components/HookForm/HookForm';
import Button from '../../components/Button/Button';
import LoaderInline from '../../components/Loader/LoaderInline';
import formatNumber from '../../utils/formatNumber';
import extractErrorMessage from '../../utils/extractErrorMessage';
import alert from '../../helpers/alert';
import {
  REQUISITES_INPUTS,
  SELLER_REQUISITES_INPUTS,
  cleanBank,
  sellerFio,
  withDefaults,
} from './NewCar/Consignment/requisitesInputs';

const reqGrid = { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr 1fr' };

const Section = ({ title, children }) => (
  <div style={{ padding: '10px 20px', backgroundColor: 'white', marginTop: 20, border: '1px solid #E0E0E0' }}>
    <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 12, color: '#8C6A3B' }}>{title}</div>
    {children}
  </div>
);

const Row = ({ label, value }) => (
  <div style={{ display: 'grid', gridTemplateColumns: '320px 1fr', padding: '6px 0', borderBottom: '1px solid #F1E9DC' }}>
    <div style={{ color: '#9C8A73' }}>{label}</div>
    <div style={{ color: '#333' }}>{value || 'â'}</div>
  </div>
);

const CarBuInfo = () => {
  const { id } = useParams();
  const dcFormRef = useRef(null);
  const sellerFormRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const load = () => {
    setLoading(true);
    setError(null);
    getBuInfo(id)
      .then((res) => setData(res?.data || null))
      .catch((e) => setError(e?.message || 'ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ Ð´Ð°Ð½Ð½ÑÑ'))
      .finally(() => setLoading(false));
  };

  useEffect(load, [id]);

  const consignment = data?.consignment;
  const owner = consignment?.seller || {};
  const dc = consignment?.requisites || {};
  const bank = consignment?.sellerRequisites || {};
  const copiedFromDc = Boolean(bank.iban && dc.iban && cleanBank(bank.iban) === cleanBank(dc.iban));

  // key Ð¸ Ð´ÐµÑÐ¾Ð»ÑÑ ÑÑÐ¸ÑÐ°ÐµÐ¼ Ð¸Ð· Ð¾Ð´Ð½Ð¸Ñ Ð¸ ÑÐµÑ Ð¶Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ð¹: Ð¸Ð½Ð°ÑÐµ Ð¿Ð¾ÑÐ»Ðµ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ñ
  // ÑÐ¾ÑÐ¼Ð° Ð¿ÐµÑÐµÐ¼Ð¾Ð½ÑÐ¸ÑÑÐµÑÑÑ ÑÐ¾ ÑÑÐ°ÑÑÐ¼Ð¸ defaultValue, Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ ÐºÐ°Ð¶ÐµÑÑÑ, ÑÑÐ¾
  // ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ Ð½Ðµ ÑÐ¾ÑÑÐ°Ð½Ð¸Ð»Ð¸ÑÑ.
  const sellerDefaults = {
    recipient: bank.recipient || sellerFio(owner),
    iban: copiedFromDc ? '' : bank.iban,
    bankName: copiedFromDc ? '' : bank.bankName,
    bic: copiedFromDc ? '' : bank.bic,
  };
  const dcKey = [dc.dcName, dc.bin, dc.address, dc.iban, dc.bankName, dc.bic].join('|');
  const sellerKey = [sellerDefaults.recipient, sellerDefaults.iban, sellerDefaults.bankName, sellerDefaults.bic].join('|');
  const dcInputs = withDefaults(REQUISITES_INPUTS, dc);
  const sellerInputs = withDefaults(SELLER_REQUISITES_INPUTS, sellerDefaults);

  const saveConsignment = async () => {
    const requisites = await dcFormRef.current.submit();
    if (!requisites) return;
    const sellerRequisites = await sellerFormRef.current.submit();
    if (!sellerRequisites) return;
    if (!owner.id) {
      alert.error('ÐÐµ ÑÐºÐ°Ð·Ð°Ð½ Ð¿ÑÐ¾Ð´Ð°Ð²ÐµÑ');
      return;
    }

    setSaving(true);
    try {
      await createConsignment({
        carId: Number(id),
        sellerClientId: owner.id,
        price: consignment.price,
        requisites,
        sellerRequisites: {
          recipient: sellerRequisites.recipient,
          iban: cleanBank(sellerRequisites.iban),
          bankName: sellerRequisites.bankName,
          bic: cleanBank(sellerRequisites.bic),
        },
      });
      alert.success('Ð ÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ñ');
      load();
    } catch (e) {
      alert.error(extractErrorMessage(e?.response?.data) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÑ');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: '10px 20px', backgroundColor: 'white', marginTop: '20px', border: '1px solid #E0E0E0' }}>
        <LoaderInline />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '10px 20px', backgroundColor: 'white', marginTop: '20px', border: '1px solid #E0E0E0', color: '#D14343' }}>
        {error}
      </div>
    );
  }

  const seller = data?.seller || data?.Seller || {};
  const buyer = data?.buyer || data?.Buyer || {};

  if (consignment) {
    const fio = sellerFio(owner);

    return (
      <div style={{ padding: '0 20px 20px 20px' }}>
        <Section title={'ÐÑÐ¾Ð´Ð°Ð²ÐµÑ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ'}>
          <Row
            label={'Ð¤ÐÐ'}
            value={
              owner.id ? (
                <a href={`/client/${owner.id}/main-data`} style={{ color: '#B45436' }}>
                  {fio || `ÐÐ»Ð¸ÐµÐ½Ñ #${owner.id}`}
                </a>
              ) : (
                fio
              )
            }
          />
          <Row label={'ÐÐÐ'} value={owner.iin} />
          <Row label={'ÐÐ¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°'} value={owner.phone} />
          <Row label={'Ð¦ÐµÐ½Ð° Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ'} value={consignment.price ? `${formatNumber(consignment.price)} â¸` : ''} />
          <Row
            label={'ÐÐ°ÑÐ° Ð¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ñ'}
            value={consignment.createdAt ? dayjs(consignment.createdAt).format('DD.MM.YYYY') : ''}
          />
        </Section>

        <HookForm
          key={`seller-${sellerKey}`}
          ref={sellerFormRef}
          border
          title="Ð¡ÑÑÑ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°"
          inputs={sellerInputs}
          grid={reqGrid}
        />
        <HookForm
          key={`dc-${dcKey}`}
          ref={dcFormRef}
          border
          title="Ð ÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ Ð´Ð¸Ð»ÐµÑÑÐºÐ¾Ð³Ð¾ ÑÐµÐ½ÑÑÐ°"
          inputs={dcInputs}
          grid={reqGrid}
        />
        <div style={{ marginTop: 16 }}>
          <Button text={saving ? 'Ð¡Ð¾ÑÑÐ°Ð½ÑÐµÐ¼â¦' : 'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'} fill onClick={saveConsignment} disabled={saving} />
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '0 20px 20px 20px' }}>
      <Section title={'ÐÐ°Ð½Ð½ÑÐµ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°'}>
        <Row label={'Ð¤Ð°Ð¼Ð¸Ð»Ð¸Ñ'} value={seller.LastName || seller.lastName} />
        <Row label={'ÐÐ¼Ñ'} value={seller.FirstName || seller.firstName} />
        <Row label={'ÐÑÑÐµÑÑÐ²Ð¾'} value={seller.MiddleName || seller.middleName} />
        <Row label={'ÐÐÐ'} value={seller.IIN || seller.iin} />
        <Row label={'ÐÐ¾Ð¼ÐµÑ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ñ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸'} value={seller.DOCUMENT_NUMBER || seller.documenT_NUMBER} />
        <Row label={'ÐÐ°ÑÐ° Ð²ÑÐ´Ð°ÑÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°'} value={(seller.DOCUMENT_GIVED_DATE || seller.documenT_GIVED_DATE) ? dayjs(seller.DOCUMENT_GIVED_DATE || seller.documenT_GIVED_DATE).format('DD.MM.YYYY') : ''} />
        <Row label={'ÐÐµÐ¼ Ð²ÑÐ´Ð°Ð½'} value={seller.DOCUMENT_ISSUED_BY || seller.documenT_ISSUED_BY} />
        <Row label={'ÐÐ´ÑÐµÑ'} value={seller.ADDRESS || seller.address} />
        <Row label={'ÐÐ¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°'} value={seller.CONTACT_PHONE || seller.contacT_PHONE} />
      </Section>

      <Section title={'ÐÐ°Ð½Ð½ÑÐµ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ (ÑÑ. Ð»Ð¸ÑÐ¾)'}>
        <Row label={'ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ ÑÑ. Ð»Ð¸ÑÐ°'} value={buyer.JuridicalName || buyer.juridicalName} />
        <Row label={'Ð¤ÐÐ Ð´Ð¸ÑÐµÐºÑÐ¾ÑÐ°'} value={buyer.JuridicalDirectorName || buyer.juridicalDirectorName} />
        <Row label={'Ð ÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ ÐºÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ð¸'} value={buyer.CompanyDetails || buyer.companyDetails} />
        <Row label={'ÐÐ¾Ð¼ÐµÑ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°'} value={buyer.ContractNumber || buyer.contractNumber} />
        <Row label={'Ð¡Ð¿Ð¸ÑÐ¾Ðº ÑÐ°Ð±Ð¾Ñ'} value={buyer.RepairWorkList || buyer.repairWorkList} />
      </Section>

      <Section title={'ÐÐ°Ð½ÐºÐ¾Ð²ÑÐºÐ¸Ðµ ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ'}>
        <Row label={'ÐÐ¾Ð¼ÐµÑ Ð±Ð°Ð½ÐºÐ¾Ð²ÑÐºÐ¾Ð³Ð¾ ÑÑÑÑÐ°'} value={seller.bankAccount} />
        <Row label={'ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ Ð±Ð°Ð½ÐºÐ°'} value={seller.bankName} />
        <Row label={'ÐÐÐ'} value={seller.bankBic} />
      </Section>
    </div>
  );
};

export default CarBuInfo;
